import { createContext, useContext } from "react";

/** Context providing authentication information */

export const AuthContext = createContext(undefined);

/**
 * @returns the current AuthContext or error if not available
 */
export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw Error("useAuthContext() must be used inside the AuthProvider component");
  }
  return context;
}